import React from 'react';
import Text from '../../app/Text';
import Header from '../Header';
import styles from './styles';
import useBrowserHistory from '../../../hooks/browserHistory';
import OnboardingBigContinueButton from '../../app/OnboardingBigContinueButton';

export default function AgeStat({ onNext, onBack, experiments }) {
  useBrowserHistory('ageStat', true, onBack, onNext);

  return (
    <div className="stat-container">
      <div className="image-container">
        <img
          src="/static/images/ageStat/BackgroudImage.png"
          alt="age-stat-image"
          className="background-image"
        />
      </div>
      <Header title="Did you know?" experiments={experiments} />
      <Text type="h3" color="b100" weight="semibold" style={{ marginTop: 12 }}>
        {`Aura has helped 2,371,421 people of your age improve their mental wellness & sleep`}
      </Text>
      <div className="button-container">
        <OnboardingBigContinueButton
          title="Continue"
          experiments={experiments}
          onClick={() => {
            onNext();
          }}
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
